<template>
  <div>
    <div class="bg" style="padding-bottom: 20px">
      <FxedTop></FxedTop>
    </div>
    <div class="page">
      <div class="pageTitle">
        <div class="sort"></div>
        <div class="currentLocation">
          当前位置：首页 > 继续教育 > 课程详情 > {{ classInfo.name }}
        </div>
      </div>
      <div class="container">
        <div>
          <div class="containent">
            <img :src="classInfo.backgroundImgSrc" class="banner" />
            <div class="course">
              <div class="courseLeft">
                <div class="courseName">
                  {{ classInfo.name }}
                  <span style="font-size: 20px">
                    {{ classInfo.joinMember }}人已加入学习，满额{{
                      classInfo.maxMember
                    }}人</span
                  >
                </div>
                <!-- <div class="courseCon">
                  <div class="conIcon">说明</div>
                  <div class="conDeacript">
                    {{ classInfo.joinMember }}人已加入学习，满额{{
                      classInfo.maxMember
                    }}人
                  </div>
                </div> -->
              </div>
            </div>

            <div class="main">
              <!-- 课程目录，排行，评论 tab切换 -->
              <div class="tab">
                <div
                  v-for="(item, index) in list"
                  :key="index"
                  @click="chooseType(item.id)"
                  :class="{ select: item.isShow }"
                  style="cursor: pointer">
                  {{ item.name }}
                </div>
              </div>

              <!-- tab 切换的 课程内容 显示 -->
              <div v-if="isCatalogue">
                <div class="mainTop">
                  <div>
                    课堂小节({{ catalogueList ? catalogueList.length : 0 }})
                  </div>
                  <div class="mainPro">
                    <div>学习进度</div>
                    <div class="proBg">
                      <div
                        class="proDetail"
                        :style="{ width: `${schedule}%` }"></div>
                    </div>
                    <div>{{ schedule }}%</div>
                  </div>
                </div>

                <div
                  class="list"
                  v-for="(item, index) in catalogueList"
                  :key="index"
                  @click="gochapter(item)"
                  style="cursor: pointer">
                  <div class="leftCon">
                    <div class="itemCon">
                      <div class="itemDesc">{{ item.name }}</div>
                      <div
                        v-if="item.isComplete == 0 && item.type != 5"
                        class="itemDetail">
                        未开始
                      </div>
                      <div
                        v-if="item.isComplete == 1 && item.type != 5"
                        class="itemDetail">
                        已完成学习
                      </div>
                      <div
                        v-if="item.isComplete == 2 && item.type != 5"
                        class="itemDetail">
                        已观看{{ parseInt(item.videoTime) / 60 }}分钟
                      </div>
                    </div>
                  </div>
                  <div v-if="item.canPlay == 1" class="rightStudy">
                    {{ item.typeName }}
                  </div>
                  <div v-else class="rightStudy" style="background: #ccc">
                    暂未开放
                  </div>
                </div>
              </div>

              <!-- tab 切换的 排行内容 显示 -->
              <div v-if="isRanking" class="ranking">
                <div
                  class="rankItem"
                  v-for="(item, index) in rankingList"
                  :key="index">
                  <div class="rankCon">
                    <div class="noun">{{ index + 1 }}</div>
                    <div class="rankImgs">
                      <img :src="item.avatar" class="rankUrlBg" />
                      <img
                        v-if="item.rank == 1 && item.avatar"
                        src="@/assets/images/jiangpai1.png"
                        class="rankIcon" />
                      <img
                        v-if="item.rank == 2 && item.avatar"
                        src="@/assets/images/jiangpai2.png"
                        class="rankIcon" />
                      <img
                        v-if="item.rank == 3 && item.avatar"
                        src="@/assets/images/jiangpai3.png"
                        class="rankIcon" />
                    </div>
                    <div>{{ item.nickname }}</div>
                  </div>
                  <div class="point">
                    <span
                      :class="[
                        index == 0
                          ? 'pointText1'
                          : index == 1 || index == 2
                          ? 'pointText2'
                          : 'pointText',
                      ]"
                      >{{ item.score }}</span
                    >
                    积分
                  </div>
                </div>
              </div>
              <!-- tab 切换的 评论内容 显示 -->
              <div v-if="isComments" class="comments">
                <div v-for="(item, index) in commentsList" :key="index">
                  <div class="commentItem">
                    <img :src="item.avatar" class="commentImg" />
                    <div class="commentCom">
                      <div class="commentName">{{ item.nickname }}</div>
                      <div class="commentText">{{ item.comment }}</div>
                      <div class="commentTime">
                        <div>{{ item.createTime }}</div>
                        <div @click="addPraise(item.id)">
                          <img v-if="item.isStar == 1" :src="okPraise" />
                          <img v-if="item.isStar == 0" :src="noPraise" />
                          {{ item.starNum ? item.starNum : 0 }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="certificate" v-if="isCatalogue">
              <div class="certificateDesc" v-if="this.schedule != 100">
                学完全部必修小节，即可获得学习证书
              </div>
              <!-- <div class="certiItem" v-if="catalogueList.userList">
                <img
                  v-for="(item, index) in catalogueList.userList"
                  :key="index"
                  :src="item.wxtx"
                  class="" />

                <div>等{{ catalogueList.num }}人已获得</div>
              </div> -->
              <!-- <div>
                <div @click.stop="credentialMask" class="credentialMask"></div>
                <canvas
                  ref="myCanvas"
                  canvas-id="myCanvas"
                  class="certificateContainer-canvas"></canvas>
                <div class="canvasImageContainer">
                  <img :src="base64" mode="" v-if="base64" />
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import { IMAGES_PATH } from "@/utils/config2.js";
import {
  getRank,
  getcomment,
  sectionList,
  commentStar,
  sectionComplete,
  getchapter,
  joincurriculum,
  getclassSearch,
  getcurriculum,
} from "@/api/wkApi.js";
import Footer from "@/components/Footer";

import FxedTop from "@/components/FxedTop";
export default {
  components: {
    FxedTop,
    Footer,
  },
  data() {
    return {
      text: "",
      base64: null,
      images1: IMAGES_PATH + "/images/yuan.png",
      gu1: "@/assets/images/jiangpai1.png",
      gu2: "@/assets/images/jiangpai2.png",
      gu3: "@/assets/images/jiangpai3.png",
      noPraise: IMAGES_PATH + "/images/microlecture/noPraise.png",
      okPraise: IMAGES_PATH + "/images/microlecture/videoIcon3.png",
      credential: IMAGES_PATH + "/images/microlecture/credential.png",
      search: IMAGES_PATH + "/images/microlecture/search.png",
      proWidth: 50,
      userInfo: {},
      meInfo: {},
      canvasImg: "",
      list: [
        {
          name: "课程目录",
          isShow: true,
          id: 1,
        },
        {
          name: "排行",
          isShow: false,
          id: 2,
        },
        {
          name: "评论",
          isShow: false,
          id: 3,
        },
      ],
      isCatalogue: true,
      isRanking: false,
      isComments: false,
      catalogueList: {}, //课程目录
      rankingList: [], // 排行列表
      commentsList: [],
      options: {},
      isDiscussion: false,
      schedule: 0,
      classInfo: {},
      pageNum: 1, //评论分页
      pageNumRank: 1, //排行榜分页
      getTime: "",
      inputValue: "",
      curriculumLisr: [],
      classId: "",
    };
  },

  mounted() {
    this.getinit();
    var date = new Date();

    let YYYY = date.getFullYear(); //获取完整的年份(4位)

    let MM = date.getMonth() + 1; //获取当前月份(0-11,0代表1月)

    let DD = date.getDate(); //获取当前日(1-31)
    let time = YYYY + "年" + MM + "月" + DD + "日";
    this.userInfo = {}; // JSON.parse(uni.getStorageSync("userInfo"));
    this.isCatalogue = true;
    this.isRanking = false;
    this.isComments = false;
    this.getTime = time;
  },
  methods: {
    conApply() {
      if (this.schedule != "100" || this.meInfo.isComplete != 1) return;
      const nickName = this.userInfo.nickName;
      const spped = this.schedule;
      const className = this.classInfo.name;
      const getTime = this.getTime;
      let ww, hh;
      const canvas = this.$refs.myCanvas; // document.getElementById("#certificate-test");
      const ctx = canvas.getContext("2d");
      // const image = this.$refs.image;

      // 引用本地图像
      const image = new Image();
      image.src = require("@/assets/images/finish_class.jpg"); // 替换为你保存的本地图像路径
      image.onload = () => {
        // src="@/assets/images/finish_class.jpg"
        // 获取 canvas-dom
        console.log("canvas----->");
        console.log(image.src);
        console.log(canvas);
        ctx.drawImage(image, 0, 0); //填充进图片

        ctx.fillStyle = "#7858a6"; //设置内容1的文字样式
        ctx.fonst = "24px";
        ctx.textAlign = "center"; //设置对于坐标点的对齐方式
        ctx.fillText(nickName, ww / 2, hh / 2 - 30); //计算距离，将文字定位于图片的某处

        ctx.fillStyle = "#000000"; //设置内容2的文字样式
        ctx.fonst = "10px";
        ctx.textAlign = "center"; //设置对于坐标点的对齐方式
        ctx.fillText(`学习进度${spped}%`, ww / 2, hh / 2 - 10);

        ctx.fillStyle = "#000000"; //设置内容2的文字样式
        ctx.fonst = "10px";
        ctx.textAlign = "center"; //设置对于坐标点的对齐方式
        ctx.fillText(
          "--------------------------------------",
          ww / 2,
          hh / 2 + 20
        );
        ctx.fillStyle = "#7858a6"; //设置内容2的文字样式
        ctx.fonst = "12px";
        ctx.textAlign = "center"; //设置对于坐标点的对齐方式
        if (className.length > 22) {
          ctx.fillText(`《${className.slice(0, 22)}`, ww / 2, hh / 2 + 40);
          ctx.fillText(`${className.slice(22)}》`, ww / 2, hh / 2 + 60);
        } else {
          ctx.fillText(`《${className}》`, ww / 2, hh / 2 + 40);
        }
        ctx.fillStyle = "#FFFFFF"; //设置内容2的文字样式
        ctx.fonst = "10px";
        ctx.textAlign = "center"; //设置对于坐标点的对齐方式
        // ctx.setFontSize(10);
        // ctx.setTextAlign("center"); //同上
        ctx.fillText(getTime, ww - 60, 355);
        setTimeout(() => {
          this.base64 = canvas.toDataURL("image/png");
          console.log(this.base64);
        }, 1200);
      };
    },
    // 计算进度条
    calculateSchedule() {
      if (
        !this.catalogueList.list ||
        JSON.stringify(this.catalogueList.list) == "[]"
      ) {
        return;
      }
      var num = 0;
      this.catalogueList.list.forEach((item, index) => {
        if (item.chapterStatus == 2) {
          num += 1;
        }
      });
      num = num * 20;
      this.schedule = num;
    },
    credentialMask() {
      this.meInfo.isComplete = 0;
    },
    rank() {
      let params = {
        classId: this.classId,
        pageNum: this.pageNumRank,
        pageSize: 10,
      };
      getRank(params).then((res) => {
        const { list = [], total = 0 } = res.result || {};
        if (!list.length && total >= 10) {
          return this.$message.warning("最后一条了哦");
        }
        if (this.pageNumRank === 1) {
          this.rankingList = list;
        } else {
          this.rankingList = [...this.rankingList, list];
        }
      });
    },
    comment() {
      let params = {
        classId: this.classId,
        pageNo: this.pageNum,
        pageSize: 10,
      };
      getcomment(params).then((res) => {
        if (JSON.stringify(res.result.list) === "[]") {
          return this.$message.warning("最后一条了哦");
        }
        if (this.pageNum === 1) {
          this.commentsList = res.result.list;
        } else {
          this.commentsList = [...this.commentsList, ...res.result.list];
        }
      });
    },
    // 小节跳转
    gochapter(obj) {
      if (obj.canPlay === 0) {
        return this.$message.warning("该小节暂未开放");
      }
      if (this.meInfo.isJoin != 1) {
        return this.$message.warning("请先加入课程才能开始学习");
      }
      if (obj.type == 1) {
        this.$router.push({
          path: "/course/literature",
          query: {
            groupId: this.$route.query.groupId,
            classId: this.classId,
            sectionId: obj.id,
          },
        });
      } else if (obj.type == 2 || obj.type == 4) {
        this.$router.push({
          path: "/course/questionnaire",
          query: {
            groupId: this.$route.query.groupId,
            classId: this.classId,
            sectionId: obj.id,
          },
        });
      } else if (obj.type == 3) {
        this.$router.push({
          path: "/course/video",
          query: {
            groupId: this.$route.query.groupId,
            classId: this.classId,
            sectionId: obj.id,
            schoolClassId: this.$route.query.schoolClassId,
            learningDuration: obj.learningDuration,
          },
        });
      } else if (obj.type == 5) {
        if (obj.isComplete === 0) {
          sectionComplete({
            classId: this.classId,
            sectionId: obj.id,
          }).then((data) => {});
          this.isDiscussion = true;
        } else {
          this.$message.warning("您已申请讨论群了");
        }
      }
    },
    joinCurriculum() {
      let params = {
        classId: this.classId,
      };
      joincurriculum(params).then((res) => {
        if (res.code == 200) {
          this.meInfo.isJoin = 1;
        } else {
          this.$message.warning("加入失败");
        }
      });
    },
    // 上拉触底
    onReachBottom() {
      // 排行榜
      if (this.isRanking) {
        if (Math.ceil(this.rankingList.total / 10) + 1 === this.pageNumRank) {
          return this.$message.warning("已经到底了哦");
        } else {
          this.pageNumRank++;
          this.rank();
        }
      }
      // 评论
      if (this.isComments) {
        if (Math.ceil(this.commentsList.total / 10) + 1 === this.pageNum) {
          return this.$message.warning("已经到底了哦");
        } else {
          this.pageNum++;
          this.comment();
        }
      }
    },
    // 获取课程详情
    async getinit() {
      const res = await getcurriculum({
        classGroupId: this.$route.query.groupId, // 路由query中获取
      });
      if (res.result && res.result.list.length > 0) {
        let obj = res.result.list[0];
        this.classId = obj.id;
        getchapter({ classId: obj.id }).then((res) => {
          this.classInfo = res.result.classInfo;
          this.discussion = res.result.classInfo.inviteImgSrc;
          this.meInfo = res.result.meInfo;
        });
        sectionList({ classId: obj.id }).then((res) => {
          if (res.code === 200) {
            this.schedule = parseInt(res.result.speed);
            this.catalogueList = res.result.list;
          }
        });
      }
    },
    chooseType(id) {
      let isCatalogue = this.isCatalogue;
      let isRanking = this.isRanking;
      let isComments = this.isComments;
      switch (id) {
        case 1:
          isCatalogue = true;
          isRanking = false;
          isComments = false;
          break;
        case 2:
          isCatalogue = false;
          isRanking = true;
          isComments = false;
          this.rank();
          break;
        case 3:
          isCatalogue = false;
          isRanking = false;
          isComments = true;
          this.comment();
          break;
        default:
          console.log("default");
      }
      let list = this.list;
      list.forEach((item, index) => {
        if (item.id === id) {
          item.isShow = true;
        } else {
          item.isShow = false;
        }
      });
      this.list = list;
      this.isCatalogue = isCatalogue;
      this.isRanking = isRanking;
      this.isComments = isComments;
    },
    // 添加点赞
    addPraise(id) {
      let params = {
        classId: this.classId,
        commentId: id,
      };
      let commentsList = this.commentsList;
      commentStar(params).then((res) => {
        commentsList.list.forEach((item, index) => {
          if (params.commentId === item.id) {
            item.isStar = res.result.records.isStar;
            if (res.result.records.isStar == 1) {
              item.starNum = parseInt(item.starNum) + 1;
            } else {
              item.starNum = parseInt(item.starNum) - 1;
            }
          }
        });
        this.commentsList = commentsList;
      });
    },
    // 搜索
    async searchValue(e) {
      this.inputValue = e.detail.value;
    },
    inputblur(e) {
      // this.curriculumLisr = []
    },
  },
};
</script>

<style lang="scss" scoped>
image {
  display: block;
}

.containent {
  width: 100%;
  min-height: 100vh;
  // background-color: #f6f6f6;
  box-sizing: border-box;
}

.top {
  width: 702px;
  display: flex;
  justify-content: space-around;
  padding-top: 30px;
  padding-bottom: 20px;
  margin: 0 auto;

  .topBtn {
    width: 100px;
    height: 60px;
    line-height: 60px;
    background: #aacd22;
    border-radius: 8px;
    font-size: 32px;
    color: #fff;
    text-align: center;
  }

  .topBack {
    background: #ed7d31;
  }

  .topLeft {
    width: 68px;
    height: 68px;
    border-radius: 50%;
  }

  .topSearch {
    width: 350px;
    position: relative;
  }

  .searchForm {
    height: 60px;

    background: #fff;
    display: flex;
    align-items: center;

    input {
      width: 288px;
      font-size: 12px;
      color: #545454;
      border: 1px solid #481c87;
      border-radius: 8px;
      padding: 10px 20px;
    }

    .search {
      width: 28px;
      height: 28px;
      margin: 0 16px;
    }
  }
}

.classList {
  width: 100%;
  min-height: 60px;
  max-height: 180px;
  background: #fff;
  border-radius: 4px;
  position: absolute;
  z-index: 2;
}

.classListItem {
  height: 60px;
  line-height: 60px;
  font-size: 24px;
  color: #999;
  text-indent: 10px;
}

.banner {
  width: 100%;
  height: 450px;
  border-radius: 20px;
  overflow: hidden;
}

.course {
  width: 86%;
  margin: 20px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .courseLeft {
    flex: 1;
    margin-right: 20px;
  }

  .joinStudy {
    width: 170px;
    height: 48px;
    line-height: 48px;
    background: #5096ac;
    border-radius: 14px;
    font-size: 36px;
    color: #fff;
    text-align: center;
  }

  .join {
    width: 120px;
    background: #979797;
  }

  .courseName {
    font-size: 36px;
    font-weight: 500;
    color: #4a4a4a;
  }

  .courseCon {
    display: flex;

    .conIcon {
      font-size: 24px;
      color: #fff;
      background: #5096ac;
      border-radius: 10px;
      padding: 2px 10px;
      margin-right: 16px;
    }

    .conDeacript {
      font-size: 24px;
      color: #4a4a4a;
    }
  }
}

.main {
  width: 100%;
  min-height: 300px;
  background: #fff;
  padding: 24px 40px;
  border-radius: 5px;
  box-sizing: border-box;

  .tab {
    display: flex;
    justify-content: space-between;
    font-size: 24px;
    color: #4a4a4a;
    line-height: 52px;
    padding-bottom: 32px;
    border-bottom: 1px solid #dcdcdc;

    .select {
      // background: #5096ac;
      // color: #fff;
      border-bottom: 2px solid #004e99;
    }

    div {
      width: 150px;
      text-align: center;
    }
  }

  .mainTop {
    display: flex;
    justify-content: space-between;
    font-size: 22px;
    font-weight: 400;
    margin: 15px auto;

    .mainPro {
      display: flex;
      align-items: center;
      font-size: 22px;
      color: #404040;

      .proBg {
        width: 200px;
        height: 10px;
        background-color: #efefef;
        border-radius: 20px;
        margin: 0 4px;
        font-size: 12px;

        .proDetail {
          height: 10px;
          background-color: #aacd22;
          border-radius: 20px;
        }
      }
    }
  }
}

.list {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  border-bottom: 1px solid #dcdcdc;
}

.list:last-child {
  border-bottom: none;
}

.list .itemImg {
  width: 60px;
  height: 60px;
  margin-right: 12px;
}

.leftCon {
  width: 85%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.itemCon {
  flex: 1;
}

.itemNum {
  font-size: 18px;
  font-weight: 400;
}

.itemDesc {
  font-size: 20px;
  font-weight: 400;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
}

.leftCon .itemCon .itemDetail {
  font-size: 14px;
  font-weight: 400;
}

.list .rightStudy {
  font-size: 16px;
  font-weight: 400;
  height: 40px;
  line-height: 40px;
  color: #fff;
  background: linear-gradient(180deg, #41a0f1 0%, #0a5b9f 100%);
  padding: 0 12px;
  border-radius: 10px;
}

.ranking .rankItem {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 54px 0 28px;
  border-bottom: 1px solid #dcdcdc;
}

.ranking .rankItem:last-child {
  border-bottom: none;
}

.ranking .rankItem .rankCon {
  font-size: 24px;
  color: #5e5e5e;
  display: flex;
  align-items: center;
}

.rankCon .noun {
  width: 80px;
  font-size: 28px;
}

.rankCon .rankImgs {
  width: 100px;
  position: relative;
  margin-right: 20px;
}

.rankCon .rankUrlBg {
  width: 100px;
  height: 100px;
  border-radius: 50%;
}

.rankCon .rankIcon {
  width: 44px;
  height: 38px;
  position: absolute;
  top: -32px;
  left: 50%;
  margin-left: -22px;
}

.ranking .rankItem .point {
  font-size: 24px;
  color: #5e5e5e;
}

.point .pointText {
  font-size: 32px;
  font-weight: bold;
}

.point .pointText1 {
  font-size: 38px;
  font-weight: bold;
}

.point .pointText2 {
  font-size: 32px;
  font-weight: bold;
}

.comments .commentItem {
  .commentImg {
    width: 106px;
    height: 106px;
    border-radius: 50%;
    margin-right: 20px;
  }

  .commentCom {
    flex: 1;
  }

  .commentName {
    font-size: 24px;
    color: #5e5e5e;
    margin-bottom: 8px;
  }

  .commentText {
    font-size: 28px;
    margin-bottom: 16px;
    text-align: justify;
  }

  .commentTime {
    width: 100%;
    font-size: 24px;
    color: #979797;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.comments .commentItem {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 54px 0 28px;
  border-bottom: 1px solid #dcdcdc;
}

.commentItem:last-child {
  border-bottom: none;
}

.commentTime div:nth-child(2) {
  display: flex;
  align-items: center;
}

.commentTime image {
  width: 24px;
  height: 24px;
  display: inline-block;
  margin-right: 10px;
}

.certificate {
  width: 100%;
  background: #fff;
  margin-top: 16px;
  box-sizing: border-box;
  padding: 36px;
  border-radius: 5px 5px 0 0;
}

.certificate .certificateDesc {
  font-size: 22px;
  font-weight: 400;
  text-align: center;
}

.certificate .certiItem {
  font-size: 22px;
  display: flex;
  justify-content: center;
  margin: 8px;
  line-height: 52px;
}

.certificate .certiItem image {
  width: 52px;
  height: 52px;
  margin-right: 8px;
  border-radius: 52px;
}

.credentialMask {
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
}

.certificateContainer-canvas {
  width: 1241px;
  height: 1754px;
  position: absolute;
  top: 100px;
  left: 100px;
  right: 0;
  bottom: 0;
  z-index: 3;
}

.canvasImageContainer {
  width: 1241px;
  height: 1754px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  z-index: 999;
}

.canvasImageContainer image {
  width: 1241px;
  height: 1754px;
}

.certificate .certificateBg {
  width: 1241px;
  height: 1754px;

  .certificate_name {
    width: 100%;
    position: absolute;
    text-align: center;
    top: 280px;
    font-size: 40px;
    font-weight: 700;
  }

  .certificate_schedule {
    width: 100%;
    font-size: 20px;
    color: #000;
    position: absolute;
    top: 330px;
    text-align: center;
  }

  .certificate_complete {
    font-size: 20px;
    color: #000;
    position: absolute;
    top: 355px;
    width: 60%;
    text-align: center;
    border-bottom: 1px dashed #000;
    left: 50%;
    transform: translateX(-50%);
    height: 60px;
    line-height: 60px;
  }

  .certificate_realize {
    position: absolute;
    top: 430px;
    font-size: 40px;
    font-weight: 700;
    width: 100%;
    text-align: center;
  }

  .certificate_time {
    position: absolute;
    bottom: 44px;
    color: #fff;
    width: 216px;
    text-align: center;
    font-size: 20px;
    right: 14px;
  }

  .certificate_img {
    width: 56px;
    height: 56px;
    position: absolute;
    bottom: 90px;
    right: 96px;
  }

  .applyBook {
    width: 100%;
    margin-top: 40px;
  }

  .applyBook .applyImg {
    width: 212px;
    height: 56px;
    margin: 10px auto;
  }

  .applyBook .applyList {
    width: 100%;
    padding: 0 42px 92px;
    background: #fff;
    box-sizing: border-box;
  }

  .applyBook .applyList .items {
    padding: 40px 0 52px;
    border-bottom: 1px solid #dcdcdc;
    display: flex;
  }

  .items .itemImg {
    width: 176px;
    height: 176px;
    margin-right: 20px;
  }

  .items .itemCon {
    color: #404040;
    font-weight: 400;
    font-size: 28px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .items .itemCon .conTitle {
    font-size: 34px;
  }

  .items .itemCon .conRes {
    font-size: 26px;
  }

  .items .itemCon .conApply {
    width: 140px;
    font-size: 28px;
    color: #fff;
    border-radius: 10px;
    text-align: center;
  }
}
</style>
